<template>
  <div>
    <p class="mb-4">
      Bindet Ihr Euer kompatibles Türklingelsystem in die HyperFonie ein, so genießt den entsprechenden Komfort. Nutzt Zeitsteuerungen der Klingeltaster, steuert die unterschiedlichsten Rufziele, wendet flexible Weiterleitungen an oder profitiert vom direkten Sprechen mit auch komfortabler Tür-Öffnung auf Knopfdruck.
    </p>
    <p class="mb-4">
      Nicht nur über unsere PC-Software, sondern wie es sich für uns als Systemanbieter verhält, auch über die schnurgebundenen und schnurlosen AGFEO Systemgeräte. Und zur eindeutigen akustischen Unterscheidung eines Türrufes von normalen Anrufern gibt’s an solchen AGFEO Systemgeräten selbstverständlich auch einen klaren Ding/Dong-Klingelton.
    </p>
    <p class="mb-4">
      Und auch mobil wird’s komfortabel: <br>
      Über die AGFEO Dashboard App können Türgespräche direkt per VoIP geführt werden – inklusive Anzeige von Live- oder Standbildern einer angebundenen Türkamera. Während des Gesprächs lässt sich die Tür bequem per Knopfdruck öffnen – ganz ohne Kenntnis von Steuercodes.
    </p>
    <p>
      Perfekt, oder?
    </p>
  </div>
</template>

<script>
export default {
  name: 'door-bell',
}
</script>
